import * as React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';
import { connect } from 'react-redux';

import { ModalFrame, ModalFrameFooter, ModalOpener } from 'components/modal';
import TabsSection from 'components/tabs/tabs-section/TabsSection';
import CreateNewProfilesUploadForm from './components/create-new-profiles-upload-form/CreateNewProfilesUploadForm';
import CreateProfilesManualForm from './components/create-profiles-manual-form/CreateProfilesManualForm';
import CreateNewProfilesModalButtons from './components/create-new-profiles-modal-buttons/CreateNewProfilesModalButtons';

import {
  CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER,
  CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER
} from 'modules/create-new-profiles/constants/common';

import {
  changeModalTabSection,
  closeAddEntitiesModal
} from 'modules/create-new-profiles/reducers/actions';
import 'modules/create-new-profiles/reducers/reducers';

import { __t, applyTranslations } from 'utils/language';


import './create-new-profiles-modal.scss';

applyTranslations(require('./create-new-profiles-modal.i18n.json'));

import { CreateNewProfilesTabIdentifier } from 'modules/create-new-profiles/types/general';
import { State } from 'types';

interface StateProps {
  activeTab: CreateNewProfilesTabIdentifier,
  isOpen: boolean
}

interface DispatchProps {
  dispatchOnClose: () => void,
  dispatchChangeTab: (t: CreateNewProfilesTabIdentifier) => void
}

type Props = StateProps & DispatchProps;

const CreateNewProfilesModal = ({
  activeTab,
  isOpen,
  dispatchOnClose,
  dispatchChangeTab
}: Props): JSX.Element => {
  const frameContentClassNames = classnames({
    'create-new-profiles-modal__frame-content': true,
    'create-new-profiles-modal__frame-content--upload-form':
      activeTab === CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER
  });

  return (
    <ModalOpener
      showClose
      width="large"
      open={isOpen}
      onClose={dispatchOnClose}
    >
      <ModalFrame
        classNameFrame="create-new-profiles-modal__frame"
        title={__t('create_new_profiles_modal.title')}
      >
        <TabsSection
          items={[
            {
              identifier: CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER,
              label: __t('create_new_profiles_modal.tabs.manual')
            },
            {
              identifier: CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER,
              label: __t('create_new_profiles_modal.tabs.template')
            }
          ]}
          activeTab={activeTab}
          size="normal"
          className="create-new-profiles-modal__tabs"
          onClick={id => {
            if (isNil(id)) {
              return;
            }

            dispatchChangeTab(id as CreateNewProfilesTabIdentifier);
          }}
        />
        <div className={frameContentClassNames}>
          {activeTab === CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER ? (
            <CreateProfilesManualForm />
          ) : null}
          {activeTab === CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER ? (
            <CreateNewProfilesUploadForm />
          ) : null}
        </div>
        <ModalFrameFooter>
          <CreateNewProfilesModalButtons />
        </ModalFrameFooter>
      </ModalFrame>
    </ModalOpener>
  );
};

const mapStateToProps = ({ createNewProfiles }: State): StateProps => ({
  activeTab: createNewProfiles.createEntitiesModal.type,
  isOpen: createNewProfiles.activeModal === 'add-entities'
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchOnClose: () => dispatch(closeAddEntitiesModal()),
  dispatchChangeTab: tab => dispatch(changeModalTabSection(tab))
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewProfilesModal);
